import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import EdvisorWidget from '../components/edvisor/EdvisorWidget';

const Edvisor: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1600, 
      mx: 'auto',
      width: '100%',
      minWidth: 0, // Allow the container to shrink
      overflow: 'hidden', // Prevent horizontal overflow
      ...(isMobile && {
        px: 0.5, // Reduce padding on mobile
      }),
    }}>
      <EdvisorWidget />
    </Box>
  );
};

export default Edvisor;